import Select from 'react-select';
import { Check, X } from 'lucide-react';
import { useThemeConfig } from '@/components/ui/theme-config-provider';
import { UserProduct } from '@/types';
import { ImportMatchItem } from './import-list-types';

interface ImportListRowProps {
  row: ImportMatchItem;
  index: number;
  products: UserProduct[];
  onChange: (index: number, value: string | null) => void;
}

const ImportListRow = ({ row, index, products, onChange }: ImportListRowProps) => {
  const { theme } = useThemeConfig();
  const options = [
    { value: 'new', label: 'Crea Nuovo' },
    ...products.map((p) => ({ value: p.id, label: p.name })),
  ];
  const value = row.selectedId
    ? options.find((o) => o.value === row.selectedId)
    : options[0];

  return (
    <div role="row" className="grid grid-cols-[1fr_1fr_auto] gap-2 items-center">
      <div role="cell" className="truncate" aria-label="testo originale">
        {row.original}
      </div>
      <Select
        options={options}
        value={value}
        onChange={(opt) => onChange(index, opt?.value === 'new' ? null : opt?.value || null)}
        placeholder="Cerca prodotto..."
        styles={{
          control: (base) => ({
            ...base,
            minHeight: '32px',
            backgroundColor: theme.backgroundColor,
            color: theme.textColor,
            borderColor: theme.borderColor,
            fontSize: '0.875rem',
          }),
          menu: (base) => ({ ...base, backgroundColor: theme.backgroundColor }),
        }}
      />
      {row.selectedId ? (
        // Feedback visivo immediato sullo stato di abbinamento
        <Check className="h-4 w-4" style={{ color: theme.successColor }} aria-label="Abbinato" />
      ) : (
        <X className="h-4 w-4" style={{ color: theme.errorColor }} aria-label="Non abbinato" />
      )}
    </div>
  );
};

export default ImportListRow;
